import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FiGift, FiPackage, FiTruck } from "react-icons/fi";
import siteConfig, { formatPrice } from "../config/siteConfig";
import "../css/footer.scss";

function Footer() {
  const location = useLocation();
  if (["/checkout", "/paysuccess", "/payment"].includes(location.pathname)) return null;

  return (
    <footer className="site-footer" role="contentinfo">
      <section className="service-strip" aria-label="Shop benefits">
        <article>
          <FiTruck aria-hidden="true" />
          <div>
            <h3>Flat-rate shipping</h3>
            <p>
              {formatPrice(siteConfig.shipping.flatRate)} per order.
            </p>
          </div>
        </article>
        <article>
          <FiGift aria-hidden="true" />
          <div>
            <h3>Helpful customer care</h3>
            <p>Thoughtful support for products and orders.</p>
          </div>
        </article>
        <article>
          <FiPackage aria-hidden="true" />
          <div>
            <h3>Careful packing</h3>
            <p>Orders are protected with practical, recyclable materials.</p>
          </div>
        </article>
      </section>

      <section className="newsletter-block">
        <div>
          <p className="eyebrow">Need a hand?</p>
          <h2>We are here to help.</h2>
          <p>Questions about a product, delivery or an existing order are welcome.</p>
        </div>
        <a className="button button--light" href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>
      </section>

      <div className="footer-main">
        <div className="footer-brand">
          <Link className="footer-logo" to="/">
            <img src={siteConfig.logo} alt="" width="48" height="48" />
            <span>{siteConfig.displayName}</span>
          </Link>
          <p>{siteConfig.description}</p>
          <p>{siteConfig.contact.location}</p>
        </div>

        <nav aria-label="Shop links">
          <h3>My store</h3>
          <Link to="/shop?collection=new">New arrivals</Link>
          <Link to="/shop?collection=limited">Limited-time picks</Link>
          <Link to="/shop?collection=restock">Restocks</Link>
          <Link to="/shop">All products</Link>
        </nav>

        <nav aria-label="Support links">
          <h3>Support</h3>
          <Link to="/about">About us</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/shipping">Shipping policy</Link>
          <Link to="/returns">Returns & refunds</Link>
        </nav>

        <nav aria-label="Legal links">
          <h3>Information</h3>
          <Link to="/privacy">Privacy policy</Link>
          <Link to="/cookies">Cookie policy</Link>
          <Link to="/faqs">FAQs</Link>
          <Link to="/terms">Terms of service</Link>
          <a href={`mailto:${siteConfig.contact.email}`}>
            {siteConfig.contact.email}
          </a>
        </nav>
      </div>

      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} {siteConfig.brandName}. Built for small
          moments on paper.
        </p>
        <div aria-label="Accepted payment methods">
          <span>VISA</span><span>MASTERCARD</span><span>AMEX</span><span>APPLE PAY</span><span>GOOGLE PAY</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
